import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';

const defaultTextError = {
  fontFamily: 'figtree-regular',
  fontSize: 12,
  lineHeight: 16,
  color: Colors.red1,
  margin: 0,
  transition: 'all 0.3s ease',
};

const formControlContainer = {
  paddingHorizontal: 0,
};

const transparentFormControl = {
  width: '100%',
  height: isWeb ? 35 : 45,
  paddingHorizontal: 16,
  borderRadius: 4,
  borderWidth: 1,
  borderColor: '#E8E8E8',
  alignItems: 'center',
};

const formControl = {
  width: '100%',
  height: isWeb ? 35 : 45,
  paddingHorizontal: 16,
  backgroundColor: 'transparent',
  borderRadius: 4,
  borderWidth: 1,
  borderColor: '#f5f5f5',
  alignItems: 'center',
};

const formMultilineControl = {
  height: 'auto',
  minHeight: isWeb ? 35 : 45,
  paddingVertical: 6,
};

const formControlError = {
  ...formControl,
  backgroundColor: '#FFFFFF',
  borderColor: Colors.red1,
  transition: 'border-color 0.3s ease-in, border-color 0.3s ease-out',
};

const formControlFocus = {
  ...formControl,
  backgroundColor: '#FFFFFF',
  borderColor: '#A3A8B1',
  transition: 'border-color 0.3s ease-in, border-color 0.3s ease-out',
};

const formGroup = {
  position: 'relative',
  width: '100%',
  paddingHorizontal: 6,
};

const formGroupSpace = {
  marginBottom: 10,
};

const formWrapper = {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
};

const formInputText = {
  fontSize: 12,
  color: '#404040',
  fontFamily: 'figtree-regular',
  lineHeight: !isNative ? 18 : 14,
};

const formInputTextError = {
  ...defaultTextError,
  marginTop: 9,
  marginBottom: 8,
};

const formLabel = {
  marginBottom: 8,
  fontSize: 11,
  lineHeight: 21,
  fontFamily: 'figtree-regular',
  color: '#303030',
  fontWeight: 'normal',
};

const formLabelError = {
  ...defaultTextError,
  marginBottom: 8,
  lineHeight: 21,
  color: '#303030',
};

export {
  formControlContainer,
  formControl,
  transparentFormControl,
  formMultilineControl,
  formControlError,
  formControlFocus,
  formGroup,
  formGroupSpace,
  formWrapper,
  formInputText,
  formInputTextError,
  formLabel,
  formLabelError,
  defaultTextError,
};
